const deviceTranslation = {
  mode: 'en',
  menu: 'Device',
  listMenu: 'Manage Device',
  versionMenu: 'Manage Mommybox Version',
  agentVersionMenu: 'Manage Agent Version',

  searchDevice: 'Search Device',
  editDeviceDetail: 'Device Info Edit',
  editDevice: 'Edit Device Info',
  addDevice: 'Add Device',
  batchAddDevice: 'Batch Add Device',

  // Batch add related
  batchAdd: 'Batch Add',
  downloadTemplate: 'Download Template',
  uploadExcelFile: 'Upload Excel File',
  dataValidation: 'Data Validation',
  validationInProgress: 'Checking for duplicates with database...',
  validationComplete: 'Validation Complete',

  // Error messages
  requiredFieldError: 'is required',
  duplicateInFileError: 'Duplicate device name in file',
  duplicateInDatabaseError: 'Device name already exists in database',

  // Statistics messages
  validationSummary: 'Total {{total}} items: {{valid}} ready to register, {{invalid}} errors',
  duplicateStatistics:
    'File duplicates: {{file}}, DB duplicates: {{database}}, Other errors: {{other}}',

  // Batch add modal related
  uploadFileDescription: 'Upload Excel file',
  uploadDataDescription: 'Review uploaded data',
  hospitalRoomSelectionDescription: 'Select hospital and room to register devices',
  downloadTemplateDescription: 'Click the button below to download the sample Excel file.',
  uploadFileInfo: 'Upload the Excel file with your data.',
  fileSizeLimit: 'File size cannot exceed 10MB.',
  rowLimit: 'Maximum {{max}} rows can be processed. Current file: {{current}} rows',
  fileParsingError: 'An error occurred while reading the file. Please check the file format.',
  fileTypeError: 'Only Excel files (.xlsx, .xls) can be uploaded.',
  validationCompleteStatus: '{{count}} devices are ready for registration.',
  hospitalRoomSelectionInfo: 'Select the hospital and room to register devices.',
  selectHospital: 'Select Hospital',
  selectRoom: 'Select Room',
  hospitalSelection: 'Hospital Selection',
  roomSelection: 'Room Selection',
  registrationReady: 'Ready to Register',
  registrationNotPossible: 'Cannot Register',
  errorMessage: 'Error Message',
  index: 'No.',
  previous: 'Previous',
  next: 'Next',
  validationInProgressStatus: 'Validating...',
  batchRegistration: 'Register {{count}} Devices',
  partialSuccess: '{{success}} registered successfully, {{failure}} failed',
  failureItems: 'Failed items: {{items}}',
  registrationSuccess: 'All {{count}} devices have been registered successfully.',
  batchRegistrationFailed: 'Batch registration failed.',
  registrationError: 'An error occurred while registering devices.',
  addDeviceVersion: 'Add Version',
  recordingSetting: 'Device Settings',
  deviceSetting: 'Peripheral Device Settings',
  functionSetting: 'Function Settings',
  captureSwitchSetting: 'Capture Switch Settings',
  recordingScreenSetting: 'Screen Settings',
  autoUpdateSetting: 'Auto Update Settings',
  advancedSetting: 'Advanced Settings',
  developerSetting: 'Developer Mode Settings',
  captureSetting: 'Capture and Recording Settings',
  info: 'Device Information',
  hospitalInfo: 'Account Information',
  sysInfo: 'Device data collection list',
  sysInfoDescription: 'Settings are only available when the device is online.',

  hospitalLabel: 'Account',
  hospitalRoomLabel: 'Location',
  maxRecordingTimeLabel: 'Maximum Recording Time',
  motionThresholdLabel: 'Motion Detection Sensitivity',
  recordingCardSelectModeLabel: 'Audio Recording Device',
  captureSoundLabel: 'Beep Volume for Photo Capture',
  captureOnRecordingLabel: 'Capture During Recording Only?',
  pauseResumeLabel: '"Resume" & "Pause" Sound',
  diaryCaptureLabel: 'Allow Photo Capture',
  checkInvalidBarcodeLabel: 'Check Invalid Barcode',
  checkInvalidBarcodeDescription:
    'This setting turns expired barcode blocking and pink barcode blocking on or off together. If either Block Expired Barcode or Block Pink Barcode is set individually to any value other than [-1], this setting is ignored and the individual setting takes priority. Individual blocking settings are saved on the server, but only take effect on devices running build 304 or later.',
  checkExpiredBarcodeLabel: 'Block Expired Barcode',
  checkPinkBarcodeLabel: 'Block Pink Barcode',
  checkPinkBarcodeDescription:
    'On devices running build 313 or later, enabling Block Pink Barcode blocks every barcode in the pink barcode issuance list, regardless of recording history. Barcodes registered in the blocking exception list are exempt from pink barcode blocking.',
  checkPinkBarcodePeriodLabel: 'Block Pink Barcode After Usage Period',
  checkPinkBarcodePeriodDescription:
    'Blocks new recordings with a pink barcode after the configured period from its first recording. Support is planned for device build 312 or later; this setting has no effect on build 311 or earlier. If Block Pink Barcode is also enabled, pink barcodes are blocked immediately regardless of the usage period.',
  pinkBarcodeValidDaysLabel: 'Pink Barcode Usage Period (Days)',
  pinkBarcodeValidDaysDescription:
    'Defaults to 60 days. The first registration date remains unchanged, and period changes apply to existing users from their next scan. Turning period blocking off preserves the configured period.',
  pinkBarcodeValidDaysValidation: 'Enter a positive whole number for the usage period.',
  motionTimeoutLabel: 'Motion Detection Timeout',
  checkScreensaverLabel: 'Check Screensaver Mode',
  imageQualityCheckLabel: 'Check Image Quality During Recording',
  recordingMediaValidationLabel: 'Video and Audio Quality Check After Recording',
  recordingMediaValidationDescription:
    'Requires 2.11.310 or later. Checks for silence and video issues after recording and reports detected issues. Changes apply without restarting; checks already in progress will finish.',
  recordingMediaValidationDisabledOption: '[0] Disable',
  recordingMediaValidationEnabledOption: '[1] Enable (Default)',
  recordingVideoFreezeThresholdLabel: 'Frozen Screen Detection Threshold (Seconds)',
  recordingVideoFreezeThresholdDescription:
    'Default: 600 seconds (10 minutes). Alerts when the screen remains frozen for at least this long. Used when quality checks are enabled; changes apply from the next file check. Requires a device app update that supports this setting.',
  checkOnlineLabel: 'Check Network Status',
  autoUpdateLabel: 'Auto Update Status',
  updateTargetLabel: 'Auto Update Target Version',
  notificationFeedbackLabel: 'Enable Automatic Voice Alerts for Detected Issues',
  notificationFeedbackDescription:
    'Disabled by default. When enabled, prolonged file growth stalls trigger a recording failure voice prompt and an LED warning. Detection and repeat intervals depend on the file check interval and error failure count settings. Alerts repeat while the stall persists; the alert itself does not stop recording.',
  notificationFeedbackScopeDescription:
    'In version 2.11.310, this does not enable voice alerts for every issue. Manual voice prompts work regardless of this setting.',
  build299Required: 'Available from build 308',
  printerLabel: 'Allow Printer',
  recordingBrightnessLabel: 'Brightness',
  recordingContrastLabel: 'Contrast',
  debugModeLabel: 'Debug Mode',
  vsyncLabel: 'Video Timestamp Sync Setting',
  thresholdLuminanceLabel: 'Motion Detection Brightness Threshold',
  maxConsecutiveImageIssuesLabel: 'Maximum Allowed Image Issues',
  colorImbalanceThresholdLabel: 'Color Imbalance Threshold',
  fileMinGrowthRateLabel: 'Minimum File Growth Rate (bytes/sec)',
  fileGrowthLearningEnabledLabel: 'Enable File Growth Rate Learning',
  fileCheckIntervalLabel: 'File Check Interval (seconds)',
  fileMaxFailureLabel: 'Maximum File Check Failures',
  fileMaxFailureForErrorLabel: 'Maximum File Check Failures for Error',
  VideoMinDurationRatioLabel: 'Video Length Check Ratio',

  devicePlaceHolder: 'Enter Device Name(Serial)',
  descriptionPlaceHolder: 'Enter Device Description',
  hospitalRoomPlaceHolder: 'Select Location',
  buildNumberPlaceHolder: 'Enter Build Number',
  buildHashPlaceHolder: 'Enter Build Hash',
  versionNamePlaceHolder: 'Enter Version Name',
  versionDescriptionPlaceHolder: 'Enter Version Description',
  customInputPlaceholder: 'Enter Custom Input',

  seq: 'Seq',
  name: 'Device Name',
  deviceName: 'Device Name (Serial Number)',
  hospital: 'Account',
  version: 'Mommybox Version',
  agentVersion: 'Agent Version',
  hospitalRoom: 'Location',
  activity: 'Last Activity',
  motionThreshold: 'Motion Sensitivity',
  maxRecordingTime: 'Max Recording Time',
  minute: 'm',
  printer: 'Printer',
  capture: 'Photo Capture',
  captureSwitch: 'Capture Switch Mode',
  recordingBrightness: 'Brightness',
  recordingContrast: 'Contrast',
  recordingCardSelectMode: 'Audio Device',
  captureOnRecording: 'Capture Only During Recording',
  checkInvalidBarcode: 'Check Expired Barcode',
  checkScreensaver: 'Check ScreenSaver', // Add English name
  activeFlag: 'Active?',
  active: 'Activate',
  inactive: 'Deactivate',
  activeDevice: 'Active Device',
  inactiveDevice: 'Inactive Device',
  installFlag: 'Install?',
  install: 'Install',
  installDevice: 'Install Device',
  uninstallDevice: 'Uninstall Device',
  description: 'Device Description',
  record: 'Records',
  detailRecord: 'Detailed Records',
  uptime: 'Uptime',
  timeZone: 'Time Zone',

  vfr: 'vfr',
  cfr: 'cfr',
  main: 'Main',
  beta: 'Beta',
  custom: 'Custom',

  motionThreshold001: '[0.010] Very Sensitive',
  motionThreshold005: '[0.050] Sensitive',
  motionThreshold018: '[0.180] Normal (Default)',
  motionThreshold022: '[0.220]Less Sensitive',
  motionThreshold999: '[999.999] Motion Detection Disabled',
  captureSwitchNone: 'Capture + Capture',
  captureSwitchCs: 'Capture + Record Start/Stop',
  captureSwitchCp: 'Capture + Record Resume/Pause',
  captureSwitchSp: 'Record Start/Stop + Record Resume/Pause',
  captureSwitchPs: 'Record Resume/Pause + Record Start/Stop',
  recordingCardSelectModeDefault: 'Auto Select',
  recordingCardSelectModeYuh01: 'YUH-01 3.5mm',
  recordingCardSelectModeEzcap: 'GameDock Ultra 3.5mm',
  recordingCardSelectModeAlc255: 'PN40 Front Input',
  recordingCardSelectModeUsb: 'USB Device (0d8c:0014)',
  recordingCardSelectModeAv: 'EZCap (534d:0021)',

  buildNumber: 'Build Number',
  buildHash: 'Build Hash',
  versionName: 'Version Name',
  versionDescription: 'Version Description',
  visibleFlag: 'Visibility Status',
  autoUpdateFlag: 'Auto Update Status',
  createdAt: 'Created At',
  updatedAt: 'Updated At',

  assignedRoom: 'Assigned Location Available',
  unassignedRoom: 'No Assigned Location',
  activeDeviceMessage: ': Would you like to activate this?',
  inactiveDeviceMessage: ': Would you like to deactivate this?',
  inactiveDeviceWarningMessage:
    '* Inactive devices will not be displayed in [Device Monitoring] menu.',
  descriptionMessage: '* Typically Location(Room) Name.',
  inactiveMessage: '* Set to 0 to deactivate.',
  developerSettingWarningTitle: 'Advanced Setting Warning',
  developerSettingWarningMessage:
    'Advanced settings are not recommended for users other than developers.',
  saveVerificationSuccess: 'Saved values were verified from the server.',
  saveVerificationFailedTitle: 'Server verification failed',
  saveVerificationMismatchDescription:
    'The values returned from the server do not match the requested values.',
  saveVerificationMismatchItem: '{{field}}: requested {{expected}} / server {{actual}}',
  saveVerificationDeviceNotFound:
    'The saved device could not be found when reloading data from the server.',
  saveVerificationTargetMissing:
    'Hospital information is missing, so the saved values could not be verified.',
  saveVerificationQueryFailed:
    'An error occurred while verifying saved values from the server. The modal remains open.',
  saveVerificationUpdateFailed: 'Failed to save device settings.',
  deviceReflectMessage1: '* Available from build 248',
  deviceReflectMessage2: '* Available from build 251',
  deviceReflectMessage3: '* Available from build 252',
  deviceReflectMessage4: '* Available from build 253',
  deviceReflectMessage5: '* Available from build 257',
  deviceReflectMessage6: '* Available from build 283',
  deviceReflectMessage7: '* Available from build 251.',
  deviceReflectMessage8: '* Available from build 291.',
  deviceReflectMessage9: '* Available from build 295.',
  deviceReflectMessage10: '* Available from build 298.',
  deviceReflectMessage11:
    '* Only takes effect on devices running build 304 or later. Devices on build 303 or earlier follow the invalid barcode setting.',
  motionTimeoutMessage: '* Enter a value between 0 and 60',
  thresholdLuminanceMessage: '* Enter a value between 0 and 100',
  maxConsecutiveImageIssuesMessage: '* Enter a value between 1 and 30',
  colorImbalanceThresholdMessage: '* Enter a value between 0 and 100.0',
  fileMinGrowthRateMessage: '* Enter a value between 1000 and 1000000',
  fileCheckIntervalMessage: '* Enter a value between 3 and 60',
  fileMaxFailuresMessage: '* Enter a value between 1 and 12',
  fileMaxFailuresForErrorMessage: '* Enter a value between 1 and 120',
  videoMinDurationRatioMessage: '* Enter a value between 0.1 and 0.9',
  recordingCardSelectModeDefaultOption: 'Auto Select (Default)',
  recordingCardSelectModeYuh01Option: 'YUH-01 3.5mm',
  recordingCardSelectModeEzcapOption: 'GameDock Ultra 3.5mm',
  recordingCardSelectModeAlc255Option: '[only PN40] Front Input, Y-jack',
  recordingCardSelectModeUsbOption: 'Universal USB Input Device (Microphone) (0d8c:0014)',
  recordingCardSelectModeAvOption: 'EZCap',
  captureSwitchNoneOption: '[none] Capture + Capture (Default)',
  captureSwitchCsOption: '[cs] Capture + Record Start/Stop',
  captureSwitchCpOption: '[cp] Capture + Record Resume/Pause',
  captureSwitchSpOption: '[sp] Record Start/Stop + Record Resume/Pause',
  captureSwitchPsOption: '[ps] Record Resume/Pause + Record Start/Stop',
  optionMessage1: '[0] Disable (Default)',
  optionMessage2: '[1] Enable',
  barcodeCheckModeInheritOption: '[-1] Follow invalid barcode setting',
  barcodeCheckModeDisableOption: '[0] Disable',
  barcodeCheckModeEnableOption: '[1] Enable',
  checkScreensaverOption1: '[0] Disable',
  checkScreensaverOption2: '[1] Enable (Default)',
  captureSoundOption1: '[1] Low',
  captureSoundOption2: '[3] Medium (Default)',
  captureSoundOption3: '[5] High',
  captureOnRecordingOption1: '[0] Capture Anytime',
  captureOnRecordingOption2: '[1] Capture During Recording Only',
  pauseResumeOption1: '[0] Sound On (Default)',
  pauseResumeOption2: '[1] Sound Off',
  recordingBrightnessOption1: '[-0.10] 10% Darker',
  recordingBrightnessOption2: '[-0.08] 8% Darker',
  recordingBrightnessOption3: '[-0.06] 6% Darker',
  recordingBrightnessOption4: '[-0.04] 4% Darker',
  recordingBrightnessOption5: '[-0.02] 2% Darker',
  recordingBrightnessOption6: '[0.00] 0% (Default)',
  recordingBrightnessOption7: '[0.02] 2% Brighter',
  recordingBrightnessOption8: '[0.04] 4% Brighter',
  recordingBrightnessOption9: '[0.06] 6% Brighter',
  recordingBrightnessOption10: '[0.08] 8% Brighter',
  recordingBrightnessOption11: '[0.10] 10% Brighter',
  recordingContrastOption1: '[0.98] -2% Contrast',
  recordingContrastOption2: '[1.00] 0% Contrast',
  recordingContrastOption3: '[1.01] 1% Contrast',
  recordingContrastOption4: '[1.02] 2% Contrast',
  recordingContrastOption5: '[1.03] 3% Contrast',
  recordingContrastOption6: '[1.05] 5% Contrast',
  recordingContrastOption7: '[1.07] 7% Contrast (Default)',
  deviceActiveOption1: '[1] Active',
  deviceActiveOption2: '[0] Inactive',
  deviceInstallOption1: '[1] Installed',
  deviceInstallOption2: '[0] Uninstalled',

  versionFixFlag: 'Version Fix Setting',
  versionFix: 'mommybox v3',
  agentVersionFix: 'agent v3',
  agentVersionFixTrue: '[1] Fixed',
  agentVersionFixFalse: '[0] Unfixed',
  mommyboxVersionFixTrue: '[1] Fixed',
  mommyboxVersionFixFalse: '[0] Unfixed',
  versionFixDescription: 'Auto updates are disabled when fixed.',

  inactiveKeepHospital: 'Keep Account/Location',
  inactiveMoveToInactiveRoom: 'Move to Inactive Location',
  inactiveDeleteHospital: 'Delete Account/Location',

  // Inactive modal related
  inactiveModalTitle: 'Deactivate',
  roomProcessingMethod: 'Room Processing Method',
  additionalOptions: 'Additional Options',
  currentRoomMaintain: 'Keep current room',
  moveToInactiveRoom: 'Move to inactive room',
  moveToInactiveRoomDesc: 'Move to designated inactive account/location',
  moveToSpecificRoom: 'Move to Account/Location',
  moveToSpecificRoomDesc: 'Move to selected account/location',
  removeFromHospital: 'Remove completely from account',
  resetSettings: 'Reset settings',
  resetSettingsDesc: 'Reset all cfg1_ settings to default values',
  changeDescription: 'Change description',
  changeDescriptionPlaceholder: 'Select description or enter manually',
  changeDescriptionDesc: 'You can select default options or enter manually',
  selectHospitalAndRoom: 'Select target account and location',
  selectHospitalPlaceholder: 'Select account',
  selectRoomPlaceholder: 'Select location',
  selectHospitalFirst: 'Please select account first',
  noRoomsAvailable: 'No registered locations in the selected account',
  noRoomOption: 'No location',
  deviceInfo: 'Device Name:',
  hospitalInfoLabel: 'Account:',
  currentRoom: 'Current Location:',
  currentDescription: 'Current Description:',
  unspecified: 'Unspecified',
  none: 'None',
  lost: 'Lost',
  hospitalRoomLoadingInfo: 'Loading account information...',
  missingHospitalInfo: 'Missing account information',
  missingRoomInfo: 'Missing location information',
};

export default deviceTranslation;
